/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
            // All pages
            'common': {
                init: function () {
                    // JavaScript to be fired on all pages

                    $(window).resize(function() {
                        $('.nav-primary-mobile').css('max-height', $(window).height() - $('.nav-primary-logo').height());
                    }).resize();

                    setupNinjaCheckboxes();

                    $('.nav-burger').click(function () {

                    });

                    $('nav.nav-primary > ul > li.menu-item-has-children > a, nav.nav-primary-mobile > ul > li.menu-item-has-children > a').click(function (e) {
                        e.preventDefault();
                        $(this).toggleClass('active');
                        $(this).siblings('ul.sub-menu').collapse('toggle');
                    });

                    // Responsive property
                    function responsiveProperty(_el, values, property, css) {
                        var breaks;

                        if (_el.is('[data-banner]')) {
                            breaks = {
                                xs: breakpoints.nav_mobile_mq_range,
                                sm: breakpoints.nav_tablet_mq_range,
                                md: breakpoints.nav_desktop_mq_min,
                                lg: breakpoints.nav_desktop_mq_min
                            };
                        }
                        else {
                            breaks = {
                                xs: breakpoints.xs_mq_range,
                                sm: breakpoints.sm_mq_range,
                                md: breakpoints.md_mq_range,
                                lg: breakpoints.lg_mq_min
                            };
                        }

                        if (values.xs) {
                            enquire.register(breaks.xs, {
                                match: function () {
                                    if (css) {
                                        _el.css(property, values.xs);
                                    }
                                    else {
                                        _el.attr(property, values.xs);
                                    }
                                }
                            });
                        }
                        if (values.sm) {
                            enquire.register(breaks.sm, {
                                match: function () {
                                    if (css) {
                                        _el.css(property, values.sm);
                                    }
                                    else {
                                        _el.attr(property, values.sm);
                                    }
                                }
                            });
                        }
                        if (values.md) {
                            enquire.register(breaks.md, {
                                match: function () {
                                    if (css) {
                                        _el.css(property, values.md);
                                    }
                                    else {
                                        _el.attr(property, values.md);
                                    }
                                }
                            });
                        }
                        if (values.lg) {
                            enquire.register(breaks.lg, {
                                match: function () {
                                    if (css) {
                                        _el.css(property, values.lg);
                                    }
                                    else {
                                        _el.attr(property, values.lg);
                                    }
                                }
                            });
                        }
                    }

                    // -- Responsive property

                    // Responsive min-heights
                    $('[data-resp-min-height]').each(function () {
                        var _el = $(this);
                        var minHeights = _el.data('resp-min-height');
                        responsiveProperty(_el, minHeights, 'min-height', true);
                    });
                    // -- Responsive min-heights

                    // Responsive heights
                    $('[data-resp-height]').each(function () {
                        var _el = $(this);
                        var heights = _el.data('resp-height');
                        responsiveProperty(_el, heights, 'height', true);
                    });
                    // -- Responsive heights

                    // Responsive background images
                    $('[data-resp-background]').each(function () {
                        var _el = $(this);
                        var images = _el.data('resp-background');
                        responsiveProperty(_el, images, 'background-image', true);
                    });
                    // -- Responsive background images

                    // Responsive margin top
                    $('[data-resp-margin-top]').each(function () {
                        var _el = $(this);
                        var margins = _el.data('resp-margin-top');
                        responsiveProperty(_el, margins, 'margin-top', true);
                    });
                    // -- Responsive margin top

                    // Responsive image src
                    $('[data-resp-src]').each(function () {
                        var _el = $(this);
                        var images = _el.data('resp-src');
                        responsiveProperty(_el, images, 'src', false);
                    });
                    // -- Responsive image src

                    // Sliders
                    $('.slider').each(function () {
                        var slider = $(this).find('.slider-slides');
                        var dataConfig = $(this).data('slider-config');
                        //console.log(dataConfig);

                        var res = $(this).hasClass('featured-properties-residential');

                        var config = {
                            responsive: [],
                            controls: slider.parent().find('.slider-controls'),
                            dots: false,

                            lg: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            },
                            md: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            },
                            sm: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            },
                            xs: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        };

                        if (!dataConfig) {
                            dataConfig = {};
                        }
                        config = $.extend(config, dataConfig);

                        var initSlider = function () {

                            var responsive = [
                                {
                                    breakpoint: 9999999,
                                    settings: {
                                        slidesToShow: config.lg.slidesToShow,
                                        slidesToScroll: config.lg.slidesToShow,
                                        infinite: true
                                    }
                                },
                                {
                                    breakpoint: 1919,
                                    settings: {
                                        slidesToShow: config.md.slidesToShow,
                                        slidesToScroll: config.md.slidesToShow,
                                        infinite: true
                                    }
                                },
                                {
                                    breakpoint: 1199,
                                    settings: {
                                        slidesToShow: config.sm.slidesToShow,
                                        slidesToScroll: config.sm.slidesToShow,
                                        infinite: true
                                    }
                                },
                                {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: config.xs.slidesToShow,
                                        slidesToScroll: config.xs.slidesToShow,
                                    }
                                },
                                {
                                    breakpoint: 0,
                                    settings: "unslick"
                                }
                            ];

                            if (config.responsive && config.responsive.length > 0) {
                                if ($.inArray('xs', config.responsive) === -1) {
                                    responsive[3].settings = 'unslick';
                                }
                                if ($.inArray('sm', config.responsive) === -1) {
                                    responsive[2].settings = 'unslick';
                                }
                                if ($.inArray('md', config.responsive) === -1) {
                                    responsive[1].settings = 'unslick';
                                }
                                if ($.inArray('lg', config.responsive) === -1) {
                                    responsive[0].settings = 'unslick';
                                }
                            }

                            slider.slick({
                                infinite: true,
                                dots: config.dots,
                                arrows: true,
                                prevArrow: config.controls.find('.slider-left'),
                                nextArrow: config.controls.find('.slider-right'),

                                slidesToShow: config.lg.slidesToShow,
                                slidesToScroll: config.lg.slidesToShow,

                                responsive: responsive
                            });

                            var updateCount = function (slider) {
                                var slidesToShow = slider.slick('slickGetOption', 'slidesToShow');

                                //if (slidesToShow <= 3) {
                                var currentSlide = slider.slick('slickCurrentSlide');
                                var numSlides = slider.find('.slick-slide:not(.slick-cloned)').length;

                                var totalPages = Math.ceil(numSlides / slidesToShow);
                                var page = Math.floor((currentSlide / numSlides) * totalPages) + 1;

                                var slidesPerPage = slider.slick('slickGetOption', 'slidesToShow');
                                var currentSlides = slidesPerPage * page;

                                if (currentSlides > numSlides) {
                                    currentSlides = numSlides;
                                }

                                config.controls.find('.slider-count > span:first-child').text(currentSlides);
                                config.controls.find('.slider-count > span:last-child').text(numSlides);
                                //}
                            };

                            slider.on('init', function (slick) {
                                updateCount($(this));
                            });
                            slider.on('setPosition', function (e, slick) {
                                updateCount($(this));
                            });
                        };
                        var destroySlider = function () {
                            slider.slick('unslick');
                            slider.find('> div').removeAttr('role').removeAttr('tabindex').removeAttr('aria-describedby');
                        };

                        if (!config.responsive || config.responsive.length === 0) {
                            initSlider();
                        }
                        else {
                            var breakAbbrs = ['xs', 'sm', 'md', 'lg'];

                            $.each(breakAbbrs, function (i, breakAbbr) {
                                //console.log(breakAbbr);

                                if ($.inArray(breakAbbr, config.responsive) !== -1) {
                                    enquire.register(breakpoints[breakAbbr + '_mq_range'], {
                                        match: function () {
                                            initSlider();
                                        },
                                        unmatch: function () {
                                            destroySlider();
                                        }
                                    });
                                }
                            });

                        }

                        slider.addClass('ready');
                    });
                    // -- Sliders

                    // Chosen
                    $('.chosen-select').each(function () {
                        /*$(this).SumoSelect({
                            placeholder: placeholder
                        });

                        return;*/

                        $(this).chosen();
                        var chosen = $(this).data('chosen');

                        if (!chosen) {
                            $(this).chosen('destroy');
                            var placeholder = $(this).data('placeholder');
                            $(this).removeClass('chosen-select');
                            $(this).prepend('<option disabled></option>');
                            $(this).SumoSelect({
                                placeholder: placeholder
                            });
                            return; // Touch device
                        }

                        var chosenSelect = $(this);
                        var chosenContainer = $(this).siblings('.chosen-container');

                        var autoClose = false;
                        var chosen_resultSelect_fn = chosen.result_select;
                        var chosen_resultDeselect_fn = chosen.result_deselect;
                        var chosen_resultsBuild_fn = chosen.results_build;
                        chosen.search_contains = true;
                        var resultsScroll = 0;

                        var chosenOpening = false;
                        var chosenOpen = false;

                        var choices = chosenContainer.find('ul.chosen-choices');
                        var results = chosenContainer.find('ul.chosen-results');

                        var searchField = choices.find('li.search-field');

                        bindDeselects();

                        // Scroll to bottom
                        choices.scrollTop(choices.find('li.search-field').position().top);

                        chosen.search_results.scroll(function() {
                            resultsScroll = chosen.search_results.scrollTop();
                        });

                        chosenContainer.unbind('click');
                        chosenContainer.unbind('focus');
                        chosenContainer.unbind('mousedown');
                        chosenContainer.unbind('mouseup');

                        // Create toggler
                        var toggler = $('<a/>').addClass('chosen-toggle');
                        toggler.insertBefore(chosenContainer);
                        toggler.on('mousedown', function(e) {
                            e.preventDefault();
                            e.stopPropagation();

                        });
                        toggler.on('mouseup', function(e) {
                            e.preventDefault();
                            e.stopPropagation();

                            if(!$(this).hasClass('active')) {
                                chosenSelect.trigger('chosen:open');
                            }
                        });

                        var openable = true;

                        var results_show = chosen.results_show;
                        chosen.results_show = function(evt) {
                            if(!openable) {
                                //return;
                            }

                            openable = false;
                            results_show.call(chosen, evt);

                            setTimeout(function(){
                                openable = true;
                            }, 100);
                        };


                        chosen.result_select = function (evt) {
                            //console.log('sel');
                            var scrollTop = chosen.search_results.scrollTop();
                            var resultHighlight = null;

                            if (autoClose === false) {
                                evt['metaKey'] = true;
                                evt['ctrlKey'] = true;

                                resultHighlight = chosen.result_highlight;
                            }

                            var stext = chosen.get_search_text();

                            var result = chosen_resultSelect_fn.call(chosen, evt);

                            if (autoClose === false && resultHighlight !== null)
                                resultHighlight.addClass('result-selected');

                            //this.search_field.val(stext);
                            this.winnow_results();
                            this.search_field_scale();

                            chosen.search_results.scrollTop(scrollTop);

                            bindDeselects();

                            return result;
                        };

                        chosen.result_deselect = function(evt) {
                            //console.log('desel');
                            var scrollTop = chosen.search_results.scrollTop();
                            //console.log('deselect', evt, scrollTop, chosen.search_results);

                            var result = chosen_resultDeselect_fn.call(chosen, evt);
                            this.winnow_results();
                            this.search_field_scale();

                            bindDeselects();

                            chosen.search_results.scrollTop(resultsScroll);

                            return result;
                        };

                        function bindDeselects() {
                            chosenContainer.find('ul.chosen-results > li').click(function(evt) {

                                //console.log('clicky');
                                if(!$(this).hasClass('result-selected')) {
                                    return;
                                }

                                evt.preventDefault();
                                evt.stopPropagation();

                                var index = $(this).data('option-array-index');
                                //console.log('hello', index);

                                try {
                                    chosen.result_deselect(index);
                                    choices.find('a[data-option-array-index="' + index + '"]').parent().remove();
                                    chosen.trigger('chosen:open');
                                }
                                catch(e) {};
                            });
                        }

                        chosenSelect.on('chosen:showing_dropdown', function (e) {
                            chosenOpening = true;
                            chosenContainer.addClass('chosen-opening');
                            toggler.addClass('active');

                            setTimeout(function () {
                                chosenOpening = false;
                                chosenOpen = true;
                                chosenContainer.removeClass('chosen-opening');
                                bindDeselects();
                            }, 50);


                            bindDeselects();
                        });
                        chosenSelect.on('chosen:hiding_dropdown', function (e) {
                            chosenOpening = false;
                            chosenOpen = false;
                            chosenContainer.removeClass('chosen-opening');
                            toggler.removeClass('active');
                            bindDeselects();
                        });

                        choices.scroll(function (e) {
                            //console.log(e);

                            if (chosenOpening) {
                                //console.log('prevent open');
                                //chosenSelect.trigger('chosen:close');

                                chosenContainer.removeClass('chosen-container-active chosen-with-drop');
                                chosenContainer.find('li.search-field > input').blur();

                                e.stopPropagation();
                            }

                            //.
                        });

                        chosenContainer.find('.chosen-drop ul.chosen-results').bind('DOMSubtreeModified', function(e) {
                            if (e.target.innerHTML.length > 0) {
                                $(this).find('li').click(function() {
                                    if(!$(this).hasClass('result-selected')) {
                                        return;
                                    }

                                    var index = $(this).index('.group-option');
                                    chosenSelect.find('option').eq(index).prop('selected', false);
                                    chosenSelect.trigger('chosen:updated');
                                });
                            }
                        });

                        /*
                        choices.on('mousedown', function(e) {
                            if(!chosenOpen) {
                                return;
                            }
                            //console.log('chosen open');


                            //console.log($(this).parent());
                            if(!$(this).parent().hasClass('chosen-container-active') || $(this).parent().hasClass('chosen-opening')) {
                                return;
                            }
                            e.preventDefault();
                            e.stopPropagation();

                            $('body').trigger('click');
                            choices.find('li.search-field input').blur();
                            setTimeout(function() {
                                $('.chosen-select').trigger('chosen:close');
                            }, 100);
                        });*/
                    });
                    // -- Chosen

                    // Dropdowns
                    $('select.selectie,select.ninja-forms-field').each(function () {
                        var select = $(this);
                        var selected = $(this).find('option[selected]').val();
                        var selectie = $('<div/>').addClass('selectie-menu');

                        var placeholderText = selected;
                        if (select.find('option[selected]').length > 0) {
                            placeholderText = select.find('option:selected').text();
                        }
                        else if (select.attr('data-selectie-placeholder')) {
                            placeholderText = select.data('selectie-placeholder');
                        }
                        else if ($(this).hasClass('ninja-forms-field')) {
                            placeholderText = $(this).siblings('label').text();
                        }

                        var placeholder = $('<div/>').addClass('selectie-placeholder').text(placeholderText).appendTo(selectie);
                        var items = $('<ul/>').appendTo(selectie);

                        select.find('option').each(function () {
                            var label = $(this).text();
                            var value;

                            if ($(this).attr('value')) {
                                value = $(this).attr('value');
                            }
                            else {
                                value = label;
                            }

                            var option = $('<li/>').addClass('selectie-option').data('value', value).text(label);

                            // Placeholder element
                            if ($(this).hasClass('placeholder')) {
                                option.addClass('placeholder');
                                if (selected === '') {
                                    option.addClass('hidden');
                                }
                            }

                            if (value === selected) {
                                option.addClass('selected');
                            }

                            option.appendTo(items);
                        });

                        placeholder.on('click', function () {
                            selectie.toggleClass('selectie-open');
                        });

                        items.find('.selectie-option').on('click', function () {
                            items.find('.selectie-option.selected').removeClass('selected');
                            $(this).addClass('selected');
                            select.val($(this).data('value'));
                            placeholder.text($(this).text());
                            selectie.removeClass('selectie-open');
                            if (select.val() !== '') {
                                items.find('.placeholder').removeClass('hidden');
                            }
                            else {
                                items.find('.placeholder').addClass('hidden');
                            }
                            select.trigger('change');
                        });

                        selectie.insertAfter(select);

                        selectie.find('ul').perfectScrollbar();
                    });
                    // -- Dropdowns

                    // Form read only
                    $('input.read-only').attr('readonly', 'readonly');
                    // -- Form read only

                    // Image captions
                    $('.img-captioned').each(function () {
                        var img = $(this).find('img');
                        var title = img.attr('title');
                        $(this).find('.caption-title').text(title);
                    });
                    // -- Image captions

                    // Social widget
                    $('.share a.social').click(function (e) {
                        e.preventDefault();
                        $(this).find('.sharethis').toggleClass('hidden');
                    });
                    // -- Social widget

                    // Click outside
                    $(document).on('click dblclick touchstart touchend', function (event) {
                        if (!$(event.target).closest('.share a.social').length && !$(event.target).is('.share a.social')) {
                            $('.sharethis').addClass('hidden');
                        }
                        if (!$(event.target).closest('.selectie-menu').length && !$(event.target).is('.selectie-menu')) {
                            $('.selectie-menu').removeClass('selectie-open');
                        }
                        if (!$(event.target).is('.menu-item-has-children > a') && !$(event.target).closest('.menu-item-has-children .sub-menu').length) {
                            $('.menu-item-has-children > a').removeClass('active');
                            $('.sub-menu').collapse('hide');
                        }
                    });
                    // -- Click outside

                    jQuery(document).on('submitResponse.example', function (e, response) {
                        //console.log('resp', response);
                        $('.inquiry-modal').find('.ninja-forms-cont').scrollTop(0).perfectScrollbar('update');

                        if (response.errors == false) {
                            // Code to be fired upon a submission here
                            $('.asterix').removeClass('hidden');
                        }
                        return true;
                    });

                    // Placeholder hacks
                    $('.field-wrap').each(function () {
                        var input = $(this).find('.ninja-forms-field');
                        var placeholder = input.attr('placeholder');
                        var textArea = false;

                        if ($(this).hasClass('textarea-wrap')) {
                            //console.log('wrap', input.val());
                            placeholder = input.val();
                            textArea = true;
                        }

                        if (!placeholder) {
                            return;
                        }

                        // Required symbol
                        if ($(this).find('.ninja-forms-req-symbol').length > 0) {
                            if (input.attr('placeholder')) {
                                var textWidth = getTextWidth(placeholder, input.css('font-size'), input.css('font-family'));
                                var margin = textWidth + 15;// + parseInt($(this).css('padding-left'), 10);
                                //console.log('MARGIN', margin);
                                var asterix = $('<span/>').text('*').addClass('asterix').css('margin-left', margin).appendTo($(this));
                                //console.log('MARGIN2', asterix, asterix.css('margin-left'));

                                //console.log(placeholder, textWidth, input.css('font-size'));
                                //console.log('YES', parseInt($(this).css('padding-left'), 10));
                                //console.log('YES', textWidth + 15 + parseInt($(this).css('padding-left'), 10), textWidth, 15);

                                if (navigator.userAgent.indexOf('Trident') == -1 && !$.browser.msie && !navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
                                    input.on('keydown change', function () {
                                        setTimeout(function () {
                                            asterix.toggleClass('hidden', input.val() !== '');
                                        }, 1);
                                    });
                                }
                                else {
                                    input.on('focus', function () {
                                        asterix.addClass('hidden');
                                    });
                                    input.on('blur', function () {
                                        if (input.val() === '') {
                                            asterix.removeClass('hidden');
                                        }
                                    });
                                }
                            }
                        }
                        // -- Required symbol

                        // Italics in placeholder
                        var i1 = placeholder.indexOf('[i]');
                        if (i1 > -1) {
                            var i2 = placeholder.indexOf('[/i]');
                            var italics = placeholder.substr(i1 + 3, i2 - i1 - 3);

                            placeholder = $.trim(placeholder.substr(0, i1 - 1));
                            //console.log('NEW', placeholder);
                            if (!textArea) {
                                input.attr('placeholder', placeholder);
                            }
                            else {
                                input.val(placeholder);
                                input.siblings('input[type="hidden"]').val(placeholder);
                            }
                            var textWidth = getTextWidth(placeholder + '&nbsp;', input.css('font-size'), input.css('font-family'));

                            var italicsEl = $('<span/>').text(italics).addClass('placeholder-italics').css('text-indent', textWidth).appendTo($(this));


                            input.on('focus', function () {
                                italicsEl.addClass('hidden');
                            });

                            input.on('blur keydown change', function () {

                                setTimeout(function () {
                                    //console.log(input.val());
                                    var show;

                                    if (!textArea) {
                                        show = input.val() !== '';
                                    }
                                    else {
                                        show = input.siblings('input[type="hidden"]').val() !== input.val();
                                    }
                                    italicsEl.toggleClass('hidden', show);
                                }, 1);
                            });

                            //console.log(italics);
                        }
                        // -- Italics in placeholder
                    });
                    var repositionPlaceholders = function () {
                        //console.log('repos');

                        $('.asterix').each(function () {
                            var input = $(this).siblings('.ninja-forms-field');
                            var placeholder = input.attr('placeholder');
                            var textWidth = getTextWidth(placeholder, input.css('font-size'), input.css('font-family'));
                            $(this).css('margin-left', textWidth);
                        });
                        $('.placeholder-italics').each(function () {
                            var input = $(this).siblings('.ninja-forms-field');
                            var placeholder;

                            if (!input.is('textarea')) {
                                placeholder = input.attr('placeholder');
                            }
                            else {
                                placeholder = $(this).siblings('input[type="hidden"]').val();
                            }

                            //console.log(placeholder);
                            var textWidth = getTextWidth(placeholder + '&nbsp;', input.css('font-size'), input.css('font-family'));
                            $(this).css('text-indent', textWidth);
                        });
                    };
                    enquire.register(breakpoints.xs_mq_range, {
                        match: repositionPlaceholders
                    });
                    enquire.register(breakpoints.sm_mq_range, {
                        match: repositionPlaceholders
                    });
                    enquire.register(breakpoints.md_mq_min, {
                        match: repositionPlaceholders
                    });
                    // -- Placeholder hacks

                    // Jump links
                    $('a[href*="#"]').click(function () {
                        if (this.hash === '' || $(this).hasClass('inquiry') || $(this).data('toggle')) {
                            return;
                        }

                        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                            var target = $(this.hash);
                            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                            if (target.length) {
                                var scrollTop = target.offset().top - $('header.nav > div').outerHeight() - 10;

                                $('html, body').animate({
                                    scrollTop: scrollTop
                                }, 400);
                                return false;
                            }
                            else {
                                $('html, body').animate({
                                    scrollTop: 0
                                }, 400);
                                return false;
                            }
                        }
                    });
                    // -- Jump link
                },
                finalize: function () {
                    // JavaScript to be fired on all pages, after page specific JS is fired
                }
            },
            // Home page
            'home': {
                init: function () {
                    // JavaScript to be fired on the home page
                    var searchForm = $('header.banner .search-widget');
                    var propertyTypeSelected = searchForm.find('.property-type-selected');
                    var propertyTypeDropdown = searchForm.find('.property-type-dropdown');

                    propertyTypeSelected.click(function () {
                        propertyTypeDropdown.toggleClass('hidden');
                        $(this).toggleClass('expanded');
                    });
                    propertyTypeDropdown.click(function () {
                        var oldValue = propertyTypeSelected.data('value');
                        var oldLabel = propertyTypeSelected.text();

                        var newValue = propertyTypeDropdown.data('value');
                        var newLabel = propertyTypeDropdown.text();

                        searchForm.find('input[name="property-type"]').val(newValue).trigger('change');
                        propertyTypeSelected.text(newLabel).data('value', newValue);
                        propertyTypeDropdown.text(oldLabel).data('value', oldValue);

                        propertyTypeSelected.removeClass('expanded');
                        propertyTypeDropdown.addClass('hidden');

                        $('.featured-properties-' + newValue).removeClass('hidden');
                        $('.featured-properties-' + oldValue).addClass('hidden');

                        searchForm.attr('action', searchForm.data(newValue + '-url'));
                        $('.featured-properties .slider-controls .button').attr('href', searchForm.data(newValue + '-url'));

                        searchForm.find('.search-form-fields.' + newValue).addClass('active');
                        searchForm.find('.search-form-fields.' + oldValue).removeClass('active');

                        $(window).resize();
                        searchForm.find('.chosen-select').trigger('chosen:updated');
                        $('.featured-properties .slick-slider').slick('setPosition');

                        if(('.SumoSelect > select')[0].sumo) {
                            $('.SumoSelect > select')[0].sumo.reload();
                        }
                    });

                    $('.featured-properties .slider-left').click(function () {
                        $(this).parents('.slider').find('.slider-slides').slick('prev');
                    });
                    $('.featured-properties .slider-right').click(function () {
                        $(this).parents('.slider').find('.slider-slides').slick('next');
                    });

                    // Animated counter
                    $('.stats-modules .stats-module:first-child').one('inview', function() {
                        $('.stats-module .stats-module-number').each(function() {
                            var originalNumber = $(this).html();
                            var pad = originalNumber.length - parseInt(originalNumber).toString().length;
                            //console.log('pad', pad);
                            var padString = originalNumber.substring(originalNumber.length - pad).replace(' ', '&nbsp;'); //new Array(pad + 1).join('&nbsp;');
                            //console.log('pad2',padString);

                            var padEl = $('<span/>').css('display', 'inline-block').html(padString);
                            var padWidth = padEl.outerWidth();

                            padEl.css('overflow', 'hidden').css('display', 'none').css('vertical-align', 'bottom');

                            $(this).prop('Counter', 0).animate({
                                Counter: parseInt($(this).text())
                            }, {
                                duration: 3500,
                                easing: 'swing',
                                step: function (now) {
                                    $(this).text(Math.ceil(now).toString());
                                },
                                done: function() {
                                    $(this).html(parseInt(originalNumber).toString());
                                    padEl.appendTo($(this));
                                    setTimeout(function() {

                                        padEl.animate({
                                            duration: '500',
                                            width: 'show'
                                        });
                                    }, 500);

                                }
                            });
                        });
                    });

                    $(window).resize(function() {
                        var maxHeight = 0;
                        $('.text-modules .text-module .text-module-content').css('height', 'auto');

                        $('.text-modules .text-module .text-module-content').each(function() {
                            if($(this).outerHeight() > maxHeight) {
                                maxHeight = $(this).outerHeight();
                            }
                        });

                        $('.text-modules .text-module .text-module-content').css('height', maxHeight);
                    }).resize();
                },
                finalize: function () {
                    // JavaScript to be fired on the home page, after the init JS
                }
            },
// About us page, note the change from about-us to about_us.
            'about_us': {
                init: function () {
                    // JavaScript to be fired on the about us page
                }
            },
            'page_template_template_residential': {
                init: function () {
                    var map;

                    $('.search-widget .list-view > a, .view-controls .list-view > a').click(function (e) {
                        e.preventDefault();
                        $('.search-widget .list-view, .view-controls .list-view').addClass('active');
                        $('.search-widget .map-view, .view-controls .map-view').removeClass('active');
                        $('.list-view-container').removeClass('hidden');
                        $('.map-view-container').addClass('hidden');
                        $('.search-widget').find('input[name="show"]').val('list');
                    });
                    $('.search-widget .map-view > a, .view-controls .map-view > a').click(function (e) {
                        e.preventDefault();
                        $('.search-widget .map-view, .view-controls .map-view').addClass('active');
                        $('.search-widget .list-view, .view-controls .list-view').removeClass('active');
                        $('.map-view-container').removeClass('hidden');
                        $('.list-view-container').addClass('hidden');
                        $('.search-widget').find('input[name="show"]').val('map');

                        if (!window.showMap) {
                            map = new GMaps({
                                el: '#residences-map',
                                width: '100%',
                                height: 890,
                                click: function () {
                                    map.infoBox.setMap(null);
                                }
                            });
                        }

                        setupPropertyMap(map, true);
                        setMapBounds(map);
                    });

                    if (window.showMap) {
                        map = new GMaps({
                            el: '#residences-map',
                            width: '100%',
                            height: 890,
                            click: function () {
                                map.infoBox.setMap(null);
                            }
                        });

                        setupPropertyMap(map, true);
                        setMapBounds(map);
                    }

                    $('a.inquiry').fancybox({
                        autoSize: true,
                        maxWidth: 1000,
                        width: 'auto',
                        maxHeight: 850,
                        margin: 10,
                        beforeShow: function () {
                            $('.fancybox-inner .ninja-forms-cont').perfectScrollbar();
                            $('.fancybox-inner .ninja-forms-cont .apartment-type-text').attr('disabled', 'disabled');
                            $('.fancybox-inner .ninja-forms-cont .apartment-type').change(function () {
                                //console.log($('.fancybox-inner .ninja-forms-cont .apartment-type').val());

                                if($('.apartment-type[value="Other"]:checked').length > 0) {
                                    $('.fancybox-inner .ninja-forms-cont .apartment-type-text').removeAttr('disabled');
                                }
                                else {
                                    $('.fancybox-inner .ninja-forms-cont .apartment-type-text').attr('disabled', 'disabled');
                                }
                            });
                        }
                    });
                    $('.property .cta .button.inquiry').click(function () {
                        $('#inquiry .property').val($(this).parents('.property').find('.address').text() + ' - ' + ($(this).parents('.property').find('.borough').text()));
                        $('#inquiry .ninja-forms-response-msg').hide();
                        $('#inquiry .ninja-forms-form').show();
                    });
                }
            },
            'single_residence': {
                init: function () {
                    var map = new GMaps({
                        el: '#residence-map',
                        lat: window.lat,
                        lng: window.lng,
                        zoom: 17,
                        width: '100%',
                        height: 890
                    });

                    setupPropertyMap(map, false);

                    $('a.inquiry').fancybox({
                        autoSize: true,
                        maxWidth: 1000,
                        width: 'auto',
                        maxHeight: 850,
                        margin: 10,
                        beforeShow: function () {
                            //console.log('aaa');
                            $('.fancybox-inner .ninja-forms-cont').perfectScrollbar();
                            $('.fancybox-inner .ninja-forms-cont .apartment-type-text').attr('disabled', 'disabled');
                            $('.fancybox-inner .ninja-forms-cont .apartment-type').change(function () {
                                //console.log($('.fancybox-inner .ninja-forms-cont .apartment-type').val());

                                if($('.apartment-type[value="Other"]:checked').length > 0) {
                                    $('.fancybox-inner .ninja-forms-cont .apartment-type-text').removeAttr('disabled');
                                }
                                else {
                                    $('.fancybox-inner .ninja-forms-cont .apartment-type-text').attr('disabled', 'disabled');
                                }
                            });
                        }
                    });

                    $('a.inquiry').click(function() {
                        $('#inquiry .ninja-forms-response-msg').hide();
                        $('#inquiry .property').val(window.propertyAddress);
                        $('#inquiry .ninja-forms-form').show();
                    });
                }
            },
            'page_template_template_commercial': {
                init: function () {
                    var searchForm = $('form.search-widget');
                    var map;

                    // Borough toggle
                    searchForm.find('.search-boroughs > li').click(function () {
                        if ($(this).hasClass('active')) {
                            return;
                        }

                        $(this).siblings().removeClass('active');
                        $(this).addClass('active');
                        searchForm.find('input[name="borough"]').val($(this).data('borough'));
                        searchForm.submit();
                    });

                    $('.search-widget .list-view > a, .view-controls .list-view > a').click(function (e) {
                        e.preventDefault();
                        $('.search-widget .list-view, .view-controls .list-view').addClass('active');
                        $('.search-widget .map-view, .view-controls .map-view').removeClass('active');
                        $('.list-view-container').removeClass('hidden');
                        $('.map-view-container').addClass('hidden');
                        $('.search-widget').find('input[name="show"]').val('list');
                    });
                    $('.search-widget .map-view > a, .view-controls .map-view > a').click(function (e) {
                        e.preventDefault();
                        $('.search-widget .map-view, .view-controls .map-view').addClass('active');
                        $('.search-widget .list-view, .view-controls .list-view').removeClass('active');
                        $('.map-view-container').removeClass('hidden');
                        $('.list-view-container').addClass('hidden');
                        $('.search-widget').find('input[name="show"]').val('map');

                        if (!window.showMap) {
                            map = new GMaps({
                                el: '#residences-map',
                                width: '100%',
                                height: 890,
                                click: function () {
                                    map.infoBox.setMap(null);
                                }
                            });
                        }

                        setupPropertyMap(map, true);
                        setMapBounds(map);
                    });

                    if (window.showMap) {
                        map = new GMaps({
                            el: '#residences-map',
                            width: '100%',
                            height: 890,
                            click: function () {
                                map.infoBox.setMap(null);
                            }
                        });

                        setupPropertyMap(map, true);
                        setMapBounds(map);
                    }

                    $('a.inquiry').fancybox({
                        autoSize: true,
                        maxWidth: 1000,
                        width: 'auto',
                        maxHeight: 850,
                        margin: 10,
                        beforeShow: function () {
                            $('.fancybox-inner .ninja-forms-cont').perfectScrollbar();
                        }
                    });
                    $('.property .cta .button.inquiry').click(function () {
                        $('#inquiry .property').val($(this).parents('.property').find('.address').text() + ' - ' + ($(this).parents('.property').find('.borough').text()));
                        $('#inquiry .property-url').val($(this).parents('.property').find('.button.pdf').attr('href'));
                        $('#inquiry .ninja-forms-response-msg').hide();
                        $('#inquiry .ninja-forms-form').show();
                    });
                }
            },
            'page_template_template_property_list': {
                init: function () {
                    var map;
                    var searchForm = $('form.search-widget');

                    // sorting toggle
                    $('body').find('.sortHeader .sort').click(function () {
                        
                        if($('.sortDesc',$(this)).hasClass('active')){
                            $('.sortHeader .sort span').removeClass('active');
                            $('.sortAsc',$(this)).addClass('active');
                            var sortdirection = 'asc';
                        }
                        else if($('.sortAsc',$(this)).hasClass('active')){
                            $('.sortHeader .sort span').removeClass('active');
                            $('.sortDesc',$(this)).addClass('active');
                            var sortdirection = 'desc';
                        }
                        else{
                            $('.sortHeader .sort span').removeClass('active');
                            $('.sortDesc',$(this)).addClass('active');
                            var sortdirection = 'desc';
                        }

                        searchForm.find('input[name="sort"]').val($(this).data('sort'));
                        searchForm.find('input[name="sort-direction"]').val(sortdirection);
                        searchForm.submit();
                    });

                    $('.search-widget .list-view > a, .view-controls .list-view > a').click(function (e) {
                        e.preventDefault();
                        $('.search-widget .list-view, .view-controls .list-view').addClass('active');
                        $('.search-widget .map-view, .view-controls .map-view').removeClass('active');
                        $('.list-view-container').removeClass('hidden');
                        $('.map-view-container').addClass('hidden');
                        $('.search-widget').find('input[name="show"]').val('list');
                    });
                    $('.search-widget .map-view > a, .view-controls .map-view > a').click(function (e) {
                        e.preventDefault();
                        $('.search-widget .map-view, .view-controls .map-view').addClass('active');
                        $('.search-widget .list-view, .view-controls .list-view').removeClass('active');
                        $('.map-view-container').removeClass('hidden');
                        $('.list-view-container').addClass('hidden');
                        $('.search-widget').find('input[name="show"]').val('map');

                        if(!$('.list-view-container').hasClass('no-results')){
                            if (!window.showMap) {
                                map = new GMaps({
                                    el: '#residences-map',
                                    width: '100%',
                                    height: 890,
                                    click: function () {
                                        map.infoBox.setMap(null);
                                    }
                                });
                            }
                            setupPropertyListMap(map, true);
                            setMapBounds(map);
                        }
                    });

                    
                    if(!$('.list-view-container').hasClass('no-results')){
                        map = new GMaps({
                            el: '#residences-map',
                            width: '100%',
                            height: 890,
                            click: function () {
                                map.infoBox.setMap(null);
                            }
                        });

                        setupPropertyListMap(map, true);
                        setMapBounds(map);
                    }

                    $('a.inquiry').fancybox({
                        autoSize: true,
                        maxWidth: 1000,
                        width: 'auto',
                        maxHeight: 850,
                        margin: 10,
                        beforeShow: function () {
                            $('.fancybox-inner .ninja-forms-cont').perfectScrollbar();
                            $('.fancybox-inner .ninja-forms-cont .apartment-type-text').attr('disabled', 'disabled');
                            $('.fancybox-inner .ninja-forms-cont .apartment-type').change(function () {
                                //console.log($('.fancybox-inner .ninja-forms-cont .apartment-type').val());

                                if($('.apartment-type[value="Other"]:checked').length > 0) {
                                    $('.fancybox-inner .ninja-forms-cont .apartment-type-text').removeAttr('disabled');
                                }
                                else {
                                    $('.fancybox-inner .ninja-forms-cont .apartment-type-text').attr('disabled', 'disabled');
                                }
                            });
                        }
                    });
                    $('.property .cta .button.inquiry').click(function () {
                        $('#inquiry .property').val($(this).parents('.property').find('.address').text() + ' - ' + ($(this).parents('.property').find('.borough').text()));
                        $('#inquiry .ninja-forms-response-msg').hide();
                        $('#inquiry .ninja-forms-form').show();
                    });

                    $('.location a').on('click', function () {
                        openMap($(this).attr('data-id'));
                           
                        return false;
                    });
                    
                }
            },
        }
        ;

    var openMap = function (propertyid) {
        $('.search-widget .map-view, .view-controls .map-view').addClass('active');
        $('.search-widget .list-view, .view-controls .list-view').removeClass('active');
        $('.map-view-container').removeClass('hidden');
        $('.list-view-container').addClass('hidden');
        $('.search-widget').find('input[name="show"]').val('map');

                        
        map = new GMaps({
            el: '#residences-map',
            width: '100%',
            height: 890,
            click: function () {
                map.infoBox.setMap(null);
            }
        });
                        

        var markers = setupPropertyListMap(map, true);
            setMapBounds(map);


            google.maps.event.trigger(markers[propertyid], 'click');
    }

    var setupPropertyMap = function (map, showInfoBox) {
        map.infoBox = null;
        var latLngs = [];

        //console.log('infobox', map.infoBox);

        $.each(window.mapMarkers, function () {
            if (showInfoBox) {
                var infoContent = '';

                if (this.image) {
                    infoContent += '<img class="map-residence-image img-responsive" src="' + this.image + '" />';
                }
                infoContent += '<div class="copy">';
                infoContent += '<div class="borough">' + this.borough + '</div>';
                infoContent += '<div class="address">' + this.address + '</div>';
                infoContent += '<div class="description">' + this.description + '</div>';
                infoContent += '<a class="cta" href="' + this.url + '"';
                if (window.moreInfoNew) {
                    infoContent += ' target="_blank"';
                }
                infoContent += '>MORE INFO</a>';
                if(this.applynowavailable)
                    infoContent += '<a class="cta applynow" target="_blank" href="' + this.applynowurl + '">'+this.applynowlabel+'</a>';
                infoContent += '</div>';
            }

            var latLng = new google.maps.LatLng(this.lat, this.lng);
            latLngs.push(latLng);

            var marker = map.addMarker({
                lat: this.lat,
                lng: this.lng,
                title: this.address,
                icon: '/wp-content/themes/solil/dist/images/icons/map-marker.png',
                click: function () {
                    if (showInfoBox) {
                        if (map.infoBox) {
                            map.infoBox.setMap(null);
                        }
                        map.infoBox = new InfoBox({
                            latlng: latLng,
                            map: map.map,
                            content: infoContent,
                            alignBottom: true,
                            pixelOffset: new google.maps.Size(-33, -45)
                        });
                        map.infoBox.open(map.map, marker);
                    }
                }
            });
        });

        //map.fitLatLngBounds(latLngs.splice(2, 3));
    };

    var setupPropertyListMap = function (map, showInfoBox) {
        map.infoBox = null;
        var latLngs = [];

        //console.log('infobox', map.infoBox);

        var markers = {};


        $.each(window.mapMarkers, function () {
            if (showInfoBox) {
                var infoContent = '';

                if (this.image) {
                    infoContent += '<img class="map-residence-image img-responsive" src="' + this.image + '" />';
                }
                infoContent += '<div class="copy">';
                infoContent += '<div class="borough">' + this.borough + '</div>';
                infoContent += '<div class="address">' + this.address + '</div>';
                infoContent += '<div class="vacancies">' + this.vacancies + '</div>';
                infoContent += '<a class="cta" href="' + this.url + '"';
                if (window.moreInfoNew) {
                    infoContent += ' target="_blank"';
                }
                infoContent += '>MORE INFO</a>';
                
                infoContent += '<a class="cta applynow" href="mailto:' + this.email + '?subject='+this.borough+' - '+this.address+'&body=Login: '+this.login+'">EMAIL US</a>';
                
                if(this.superphonenumber || this.officephonenumber || this.agentphonenumber)
                    infoContent += '<a class="callUs button button-primary">Call Us</a>';

                infoContent += '<div class="contactDetails">';
                infoContent += '<span class="close-btn">close</span>';
                infoContent += '<div class="propertyid">' + this.propertyid + '<br />' + this.address + '<br />' + this.city + ', ' + this.state + ' ' + this.zip + '</div>';
                infoContent += '<div class="phones">';
                    if(this.superphonenumber)
                        infoContent += '<div class="buildingphone"><a href="tel:' + this.superphonenumber + '">' + this.superphonenumber + '</a> <span>(building)</span></div>';
                    if(this.officephonenumber)
                        infoContent += '<div class="officephone"><a href="tel:' + this.officephonenumber + '">' + this.officephonenumber + '</a> <span>(office)</span></div>';
                    if(this.agentphonenumber)
                        infoContent += '<div class="agentphone"><a href="tel:' + this.agentphonenumber + '">' + this.agentphonenumber + '</a> <span>(agent)</span></div>';
                infoContent += '</div>';
                infoContent += '</div>';

                infoContent += '</div>';
            }

            var latLng = new google.maps.LatLng(this.lat, this.lng);
            latLngs.push(latLng);

            var marker = map.addMarker({
                lat: this.lat,
                lng: this.lng,
                title: this.address,
                icon: '/wp-content/themes/solil/dist/images/icons/map-marker.png',
                click: function () {
                    if (showInfoBox) {
                        if (map.infoBox) {
                            map.infoBox.setMap(null);
                        }
                        map.infoBox = new InfoBox({
                            latlng: latLng,
                            map: map.map,
                            content: infoContent,
                            alignBottom: true,
                            pixelOffset: new google.maps.Size(-33, -45)
                        });
                        map.infoBox.open(map.map, marker);

                        setTimeout(showContactInfo, 1000);
                    }
                }
            });

            var showContactInfo = function(){
                $( ".copy" ).on( "click", ".callUs", function() {
                  $('.contactDetails').css('display','block');
                });
                $( ".copy" ).on( "click", ".close-btn", function() {
                  $('.contactDetails').css('display','none');
                });
            }

            var propertyid = this.propertyid;
            markers[propertyid]  = marker;

        });

        return markers;

        //map.fitLatLngBounds(latLngs.splice(2, 3));
    };

    var setMapBounds = function (map) {
        var latLngs = [];

        $.each(window.mapMarkers, function () {
            var latLng = new google.maps.LatLng(this.lat, this.lng);
            latLngs.push(latLng);
        });

        map.fitLatLngBounds(latLngs);
    };

    var setupNinjaCheckboxes = function () {
        $('.list-checkbox-wrap li').each(function () {
            //console.log('aa');
            if ($(this).find('label > span.checkbox').length > 0) {
                return;
            }

            var span = $('<span/>').addClass('checkbox');
            span.insertAfter($(this).find('label > input[type="checkbox"]'));
            //console.log($(this).find('label'));
        });
    };

    var getTextWidth = function (text, size, family) {
        var _$tmpSpan = $('<span/>').html(text).css({
                position: 'absolute',
                left: -9999,
                top: -9999,
                'font-size': size,
                'font-family': family
            }).appendTo('body'),
            textWidth = _$tmpSpan.width();
        _$tmpSpan.remove();

        return textWidth;
    };

    var breakpoints = {
        "xs_max": "767px", // mobile landscape
        get xs_mq_range() {
            return "screen and (max-width:" + this.xs_max + ")";
        },

        "sm_min": "768px", // tablet portrait
        "sm_max": "959px",
        get sm_mq_range() {
            return "screen and (min-width:" + this.sm_min + ") and (max-width:" + this.sm_max + ")";
        },
        get sm_mq_min() {
            return "screen and (min-width:" + this.sm_min + ")";
        },

        "md_min": "960px", // tablet landscape
        "md_max": "1199px",
        get md_mq_range() {
            return "screen and (min-width:" + this.md_min + ") and (max-width:" + this.md_max + ")";
        },
        get md_mq_min() {
            return "screen and (min-width:" + this.md_min + ")";
        },

        "lg_min": "1200px", // desktop
        get lg_mq_min() {
            return "screen and (min-width: " + this.lg_min + ")";
        },
        get lg_mq_range() {
            return "screen and (min-width: " + this.lg_min + ") and (max-width: " + this.lg_max + ")";
        }
    };

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

// Load Events
    $(document).ready(UTIL.loadEvents);

})
(jQuery); // Fully reference jQuery after this point.
